import React, { Component } from 'react'
import './vanRoutine.css'
import { fire } from '../../config/firebase'
import Social from '../front/social/social'

//animation
import AOS from 'aos';
import 'aos/dist/aos.css';

export default class NoPlate extends Component {
    state={
        shift_sort:'Manha',way:'Ida',chalao:true,days:['Domingo','Segunda-feira','Terca','Quarta-feira','Quinta-feira','Sexta-feira','Sabado'],
        user_nahe_mila : false,kitny:[]
    }
    async componentDidMount(){
       let data_array = [];

       //_________local storage____________//
       let van = JSON.parse(localStorage.getItem('van'))
    //    console.log('van',van)
       if(van){
           this.setState({
               name : van.name,
               photo : van.photo,
               uid : van.uid,
           })
           //___________________local end___________//
           
           //________________firestore___________________//
           let user = fire.firestore().collection('userRegistration');
           let van_ = fire.firestore().collection('vanRegistration').doc(van.uid);
           let plate_mili=false
           var plate;
           var loc;
           await van_.get().then(plat=>{
               console.log('plate',plat.data())
               plate = plat.data().placa;
               loc = plat.data().location;
               this.setState({plate:plat.data().placa})
            })
            
            let days=['Domingo','Segunda-feira','Terca','Quarta-feira','Quinta-feira','Sexta-feira','Sabado']
            let day = new Date().getDay();
            
            console.log('>>>>>',days[day])
            user.get().then(snap=>{
                snap.forEach((u)=>{
               console.log('***key***',u.data().length)
               if(u.data().vanPlate == plate){
                plate_mili=true
                   let d_r = user.doc(u.id).collection('routine').doc(days[day]);
                   d_r.get().then(r=>{
                    //    console.log('location>>',u.data().location)

                       //DISTANCE_CALCULATING_________________.....
                           let userLat = u.data().location.lat
                           let userLng = u.data().location.lng
                          
                            navigator.geolocation.getCurrentPosition((location) => {
                             van_.update({locatin:{lat:location.coords.latitude ,lng:location.coords.longitude}})
                                // location.coords.latitude
                                // location.coords.longitude
                            });
                            //......______________________________END..
                            
                            
                           let dist = this.getDistanceFromLatLonInKm(userLat,userLng,loc.lat,loc.lng)
                            console.log('userLat : ',userLat,'userLng : ',userLng,'driverLat : ',loc.lat,'driverLng : ',loc.lng,'__distance',dist)
                       data_array.push({va:u.data(),Ida:r.data().Ida,Volta:r.data().Volta,dist})
                       this.setState({
                           data_array
                        })
                        console.log('DATA_ARRAY',data_array)
                    }).catch(e=>{
                        alert(e.message)
                    })
                }
           })
           this.setState({user_nahe_mila:!plate_mili})
           console.log('************ye chala**************')
        }).catch(e=>{
            console.error(e.message)
            alert('akhri'+e.message)
        })
        
    }
    else{
        // alert('Please login first..')
        this.props.history.push('/')
    }
    }
    
    
realtime_listener = async () => {
   setTimeout(()=>{

       this.setState({
           chalao:false
        })
    let updated_array = [];
    
    //_________local storage____________//
    let van = JSON.parse(localStorage.getItem('van'))
    // console.log('van',van)
    if(van){
        this.setState({
            name : van.name,
            photo : van.photo,
            uid : van.uid,
        })
        //___________________local end___________//
        //_____________HABBPKKA
        //________________firestore___________________//
    let user = fire.firestore().collection('userRegistration');
    let van_ = fire.firestore().collection('vanRegistration').doc(van.uid);
    var plate;
    let plate_mili=false
    var loc;
    van_.get().then(plat=>{
    //    console.log('plate',plat.data())
     plate = plat.data().placa;
     loc = plat.data().location
    })

    let days=['Domingo','Segunda-feira','Terca','Quarta-feira','Quinta-feira','Sexta-feira','Sabado']
    let day = new Date().getDay();

    user.get().then(snap=>{
        snap.forEach(u=>{
            if(u.data().vanPlate == plate){
               
                let d_r = user.doc(u.id).collection('routine').doc(days[day]);
                d_r.onSnapshot(r=>{
                     var { data_array } =  this.state;
                     console.log('_____routine',r.data(),data_array)
                    if(data_array){
                          //DISTANCE_CALCULATING_________________.....
                       
                         
                           navigator.geolocation.getCurrentPosition((location) => {
                            van_.update({location:{lat:location.coords.latitude,lng:location.coords.longitude}})
                               // location.coords.latitude
                               // location.coords.longitude
                              
                           });
                           //......______________________________END..
                           
                           
                           
                           for(let i=0;i<data_array.length;i++){
                               if(data_array[i].va.uid == u.data().uid ){
                                   console.log('~~~~~~~~~~~~~~',data_array[i].va.location.lat,data_array[i].va.location.lng,loc.lat)
                                let dist = this.getDistanceFromLatLonInKm(data_array[i].va.location.lat,data_array[i].va.location.lng,loc.lat,loc.lng)
data_array[i] = {va:u.data(),Ida:r.data().Ida,Volta:r.data().Volta,dist}
this.setState({
    updated_array
})
}
}
// updated_array.push({va:u.data(),Ida:r.data().Ida,Volta:r.data().Volta})
// console.log('______u.data()',u.data())
}
})
             }
            })
    })
}else{
    // alert('Please Login first...')
    this.props.history.push('/')
}
            },4000)
        }
logout(){
    fire.auth().signOut().then(s=>{
        alert('logout com sucesso')
        localStorage.removeItem('van')
        this.props.history.push('/')
    }).catch(e=>{
        alert(e.message)
    })
}

deg2rad(deg) {
 return deg * (Math.PI/180)
}

 getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    var R = 6371; // Radius of the earth in km
    var dLat = this.deg2rad(lat2-lat1);  // deg2rad below
    var dLon = this.deg2rad(lon2-lon1); 
    var a = 
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * 
      Math.sin(dLon/2) * Math.sin(dLon/2)
      ; 
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
    var d = R * c; // Distance in km
    console.log('Distance+++++++>>>>>',Math.round(d))
    return d;
  }

  _delete(user,name,ind){
      let { data_array } = this.state
fire.firestore().collection('userRegistration').doc(user).delete().then(success=>{
    alert('User '+name+' deleted. Successfully.')
    data_array.splice(ind,1)
    this.setState({data_array})
}).catch(error=>{
    alert(error.message)
})
  }

  comp( a, b ) {
    if ( a.dist < b.dist ){
      return -1;
    }
    if ( a.dist > b.dist ){
      return 1;
    }
    return 0;
  }
  
    render() {
        AOS.init({duration:1000})
        let{
            name,
            data_array,
            shift_sort,
            way,
            chalao,
            updated_array,
            user_nahe_mila,
            plate,
            kitny,
        } = this.state

        let _sorted_array = data_array ? data_array.sort( this.comp ):[]
        chalao && this.realtime_listener()
        // console.log('shift_sort****render',shift_sort,data_array)
      let confirm_user = data_array ? data_array.filter((val)=>{return val.va.shift == shift_sort && val[way] == true}):[]
        // console.log('data_filter', data_array.filter((val)=>{return val[way] ==true}))
        return (
            <div className='main'>
                <div className='n_header' >
                    <h1>Arriba!</h1>
                </div>
        
<Social/>
                {/* <div className='n_body'>
                    <h1>Parabéns!</h1>
                    <h3>{name}</h3>
                    <p>We are finding students related to your plate...</p>
                    <div className="loader"></div>
                </div> */}


                <div className='n_body'>
                <div className='cmt'>
                    <button onClick={()=>this.props.history.push('/driver/vanRoutine/profile')} >Perfil</button>
                       {/* <button onClick={()=>this.props.history.push('/driver/vanRoutine/comment')}>Comment</button> */}
                       <button onClick={()=>this.logout()}>Sair</button>
                    </div>
                   <div className='main__t'>

                       <div className='shifts_input'>
                           <h4> Selecione o turno</h4>
                           <select onChange={(event)=>this.setState({shift_sort:event.target.value})}>
                               <option value='Manha'>Manha</option>
                               <option value='Tarde'>Tarde</option>
                               <option value='Noite'>Noite</option>
                           </select>

                           <div className='radio-group' onChange={(e)=>this.setState({way:e.target.value})}>
                           <label className='container'>
                               <input checked={way == 'Ida'} style={{cursor:'pointer'}}  value='Ida' name='way' style={{width:'20px'}} type='radio'/>
                           <span style={{cursor:'pointer'}} className='checkmark'></span>
                           Ida
                           </label>
                           <label className='container'>
                               <input checked={way == 'Volta'} value='Volta' name='way' style={{width:'20px'}} type='radio'/>
                               <span className='checkmark'></span>
                          Volta
                          </label>
                           </div>
                           <div style={{fontSize:'17px',margin:'5px'}}>{'Confirmar usuários para '+way+' = '+confirm_user.length}</div>
                           {user_nahe_mila && !data_array && <div style={{display:'block',margin:"10%",color:'coral'}}>Nenhum usuário encontrado para placa : {plate}</div>}
                           {!data_array && !user_nahe_mila && <div style={{display:'block',margin:"35%"}} className="loader"></div> }
                          

{

_sorted_array && _sorted_array.map((val,index)=>{
    // console.log('ida****',val[way])
   console.log('arr',kitny)
   
if(val[way] && val.va.shift === shift_sort){
    

    return(
        
        <div className='student_list' data-aos='fade-up'>
            
                               <div className='std'>
                                       <img  style={{width:'28px',borderRadius:'40%',marginRight:'5px',marginLeft:'-3px'}} alt='' src={val.va.photo}/>
                                   <div className='name'>
                                       <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',width:'75vw',maxWidth:350}}>
                                   <h5>{val.va.name}</h5>
                                   {/* <div style={{width:150}}></div> */}
                                   <p style={{alignSelf:'flex-end',float:'right'}}>{Math.round(val.dist)+'km'}</p>

                                       </div>
                                   <p>{val.va.street }</p>
                                   </div>
                                   <span className='span_close' onClick={()=>this._delete(val.va.uid,val.va.name,index)}>&times;</span>
                               </div>
                           </div>
        )
    }
    // }
    })
}

                         
                       </div>
                   {/* <div className='btn_bottom'>
                       <button onClick={()=>this.props.history.push('/driver/vanRoutine/novaturma')}>Novaturma</button>
                     <button>Editar turma</button>
                   </div> */}
                   </div>
                </div>

                <div className='n_footer'>
                    <h3>Thank you for using Arriba!</h3>
                </div>
            </div>
        )
    }
}
